var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value_adds.length)?_c('div',{staticClass:"rate-value-adds"},_vm._l((_vm.value_adds),function(value_add,index){return _c('b-alert',{key:index,attrs:{"show":"","variant":"success"}},[_vm._v(" "+_vm._s(value_add.description)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }